import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import baseUrlLiff from '../../lib/baseUrlLiff';
import liff from '@line/liff';
import Utility from "../../Consts/Utility";
import Rule from "../../Consts/Rules";

type LoginInputs = {
  userId: string;
  password: string;
  authority: number;
  access_token: string;
};
interface LineProfilePrps {
  line_profile?: string;
  idToken?: any;
}

const LoginForm = (props: LineProfilePrps) => {
  const { register, handleSubmit, formState: { errors } } = useForm<LoginInputs>();
  const [userId, setUserId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [authority, setAuthority] = useState<number>();
  const [access_token, setAccessToken] = useState<string>();
  const idToken = props.idToken;
  const navigate = useNavigate();
  const line_id = props.line_profile;

  const [cookies, setCookie] = useCookies(['authority', 'access_token', 'idToken', 'siteRecno', 'siteId']);

  useEffect(() => {
    if (cookies.authority !== null) {
    }
  }, [authority, access_token]);

  const onSubmit: SubmitHandler<LoginInputs> = async (data) => {
    try {

      const response = await axios.post(
        baseUrlLiff + "/login",
        {
          userId: userId,
          password: password,
        },
        {
          headers: {
            'LineToken': `${idToken}`,
          }
        });

      if(response.data.result == -1){
        alert("認証に失敗しました");
        return
      }

      setAuthority(response.data.authority);
      setAccessToken(response.data.access_token);

      var authority = response.data.authority;
      var access_token = response.data.access_token;
      var site_recno = response.data.siteRecno;

      setCookie('access_token', access_token, { path: '/' });
      setCookie('authority', authority, { path: '/' });
      setCookie('siteRecno', site_recno, { path: '/', maxAge: 3600 });


      if (authority !== null) {
        switch (authority) {
          case 1:
            navigate('/topmenu', { state: { authority: authority } });
            break;
          case 2:
            navigate('/site_admin', { state: { authority: authority } });
            break;
          case 3:
          case 4:
            navigate(`/dashboard/${userId}/${site_recno}`, { state: { authority: authority } });
            break;
          default:
            navigate('/', { state: { authority: authority } });
            break;
        }
      }
    } catch (error) {
      console.error("Error fetching authority:", error);
    }
  };

  return (
    <>
      <section className="login-block">
        <div className="login-box">
          <div className="login-header">
            <div className="login-title">
              LINEログイン
            </div>
          </div>
          <div className="login-body">
            <div className="login-box-elm">
              <div className="login-box-elm-name">ログインID</div>
              <div className="login-box-elm-input">
                <input
                  type="text"
                  value={userId}
                  placeholder="userId"
                  {...register('userId', Rule.rules_string_30)}
                  className={"col-320 " + (errors.userId ? "error-disp" : "")}
                  onChange={e => setUserId(e.target.value)}
                />
                {errors.userId && (
                  <div className="error-msg">
                    {errors.userId.message}
                  </div>
                )}
              </div>
            </div>
            <div className="login-box-elm">
              <div className="login-box-elm-name">パスワード</div>
              <div className="login-box-elm-input">
                <input
                  type="password"
                  value={password}
                  placeholder="password"
                  {...register('password', Rule.rules_string_255)}
                  className={"col-320 " + (errors.userId ? "error-disp" : "")}
                  onChange={e => setPassword(e.target.value)}
                />
                {errors.password && (
                  <div className="error-msg">
                    {errors.password.message}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="login-footer">
            <div className="login-action">
              <form onSubmit={handleSubmit(onSubmit)}>
                <button type="submit" className="btn btn-blue">
                  <i className="icon-login-w"></i>
                  ログイン
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="login-message">
          <p>
            <b>※データの取扱いについて</b><br />
            ・取得されたデータの管理はお客様の責任でお願い致します。<br />
            ・レンタル終了時にデータは削除されますので、ご返却までにデータダウンロードをお願いします。<br />
            以降データ閲覧、データ受け渡しなどのご要望には対応致しかねますのでご了承ください。
          </p>
        </div>
      </section>
    </>
  );
};

export default LoginForm;
